module.exports = __webpack_public_path__ + "img/ball_6.380f37a4.png";